import {NgModule} from '@angular/core';
import {PanAlreadyPresentPromptComponent} from './pan-already-present-prompt.component';
import {CommonModule} from '@angular/common';
import {
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule, MatProgressSpinnerModule, MatSelectModule
} from '@angular/material';
import {ReactiveFormsModule} from '@angular/forms';
import {MatExpansionModule} from '@angular/material/expansion';

const materialImports = [MatFormFieldModule, MatInputModule, MatCheckboxModule, MatDatepickerModule, MatButtonModule,
    ReactiveFormsModule, MatProgressSpinnerModule, MatDialogModule, MatSelectModule, MatExpansionModule];

@NgModule({
    declarations: [PanAlreadyPresentPromptComponent],
    imports: [
        CommonModule,
        materialImports
    ],
    exports: [PanAlreadyPresentPromptComponent]
})
export class PanAlreadyPresentPromptModule {
}
